const Index = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/RelatorioIndicadorPerformance/Index')

export default [
  {
    path: 'relatorio-indicador-performance',
    name: 'RelatorioIndicadorPerformance',
    component: Index,
    meta: {
      title: 'Relatório Indicador de Performance',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'relatorioIndicadorPerformance',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-indicador-performance.js